export default {
    // 订单筛选项
    filtersList: {
        method: 'get',
        url: '/orders/filters'
    },
    // 订单列表
    list: {
        method: 'get',
        url: '/orders'
    },
    // 订单详情
    detail: {
        method: 'get',
        url: '/orders/:id'
    },
    // 编辑订单
    edit: {
        method: 'patch',
        url: '/orders/:id'
    },
    // 订单工单
    workOrders: {
        method: 'get',
        url: '/orders/:id/work_orders'
    },
    // 订单工单同步
    workOrdersSync: {
        method: 'post',
        url: '/orders/:id/work_orders/sync'
    },
    // 分账记录
    tradeSplitRecords: {
        method: 'get',
        url: '/orders/trade_split_records'
    },

    // TODO: 重新分账
    tradeSplitRe: {
        method: 'post',
        url: '/orders/trade_split_records/:id/trade_split'
    }
}


// WEBPACK FOOTER //
// ./src/api/orders.js